import React from "react";

export const Checkbox = React.forwardRef(({ indeterminate,onClick, ...rest } , ref) => {
    const defaultRef = React.useRef()
    const resolvedRef = ref || defaultRef

    React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef , indeterminate])

    return(
        <>
            <input className="checkbox" type='checkbox' ref={resolvedRef} onClick={(e) => {
                e.stopPropagation();
                if (onClick) {
                    onClick(e);
                }
            }} {...rest} />
        </>
    )
})